import React from "react";
import { useNavigate } from "react-router-dom";

const Business = ({
  backgroundImage,
  language,
  title,
  buttonText,
  RedirectUrl,
}) => {
  const navigate = useNavigate();

  const titlePaddingClass = language === "ar" ? "ar-padding" : "en-padding";

  return (
    <section
      className="Business-parallax"
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <div className="Business-overlay"></div>
      <div className={`Business-content`}>
        <div className={`busin-title ${titlePaddingClass}`}>
          <h2>{title}</h2>
        </div>
        <button className="busin-button" onClick={() => navigate(RedirectUrl)}>
          {buttonText}
        </button>
      </div>
    </section>
  );
};

export default Business;
